<template>
  <div v-if="userInfo">
    <section class="header-wrap">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="nav-wrap">
              <nav class="navbar navbar-expand-lg">
                <a class="navbar-brand">
                  <div class="head-logo headerlogo logoAdjust">
                    <!-- <img
                      src="/images/logo.png"
                      class="d-none d-sm-block"
                      alt=""
                      title=""
                    /> -->

                    <img
                      v-if="
                        userInfo && (RoleOfUser === '11' || RoleOfUser === '14')
                      "
                      src="/images/Newlogo1.svg"
                      class="mb-2 header-logo cursorClass"
                      alt=""
                      title=""
                      @click="superAdminNavigation"
                    />
                    <img
                      v-else-if="userInfo && RoleOfUser === '18'"
                      src="/images/Newlogo1.svg"
                      class="mb-2 header-logo cursorClass"
                      alt=""
                      title=""
                      @click="gotoServices"
                    />
                    <img
                      v-else
                      src="/images/Newlogo1.svg"
                      class="mb-2 header-logo cursorClass"
                      alt=""
                      title=""
                      @click="residentNavigation"
                    />
                    <br />
                  </div>
                </a>
                <button
                  class="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <!-- <span class="navbar-toggler-icon"></span> -->
                  <span class="navbar-toggler-icon" style="cursor: pointer;"
                    ><i class="fa fa-bars" aria-hidden="true"></i
                  ></span>
                </button>

                <div
                  id="navbarSupportedContent"
                  class="collapse navbar-collapse"
                >
                  <div class="form-inline my-2 my-lg-0 ml-auto">
                    <ul class="navbar-nav head-right-nav mr-l">
                      <!-- Sando Admin Tab Start From Here -->
                      <li
                        v-if="
                          userInfo &&
                            (RoleOfUser === '11' || RoleOfUser === '14')
                        "
                        :class="{
                          active:
                            currentPath === 'manageVendor' ||
                            currentPath === 'editVendor' ||
                            currentPath === 'createVendor' ||
                            currentPath === 'vendor-user-list',
                        }"
                      >
                        <a
                          class="nav-link cursor-pointer"
                          @click="gotoVendorCreation"
                          >Vendors List</a
                        >
                      </li>

                      <li
                        v-if="
                          userInfo &&
                            (RoleOfUser === '11' || RoleOfUser === '14')
                        "
                        :class="{
                          active:
                            currentPath === 'vendorServices' ||
                            currentPath === 'createService' ||
                            currentPath === 'editServiceForm' ||
                            currentPath === 'manageBuildings' ||
                            currentPath === 'sequenceOrderServiceForm',
                        }"
                      >
                        <a
                          class="nav-link cursor-pointer"
                          @click="gotoServicesCreation"
                          >Vendor Services</a
                        >
                      </li>
                      <li
                        v-if="
                          userInfo &&
                            (RoleOfUser === '11' || RoleOfUser === '14')
                        "
                        :class="{
                          active:
                            currentPath === 'manageDistribution' ||
                            currentPath === 'manageServiceform',
                        }"
                      >
                        <a
                          class="nav-link cursor-pointer"
                          @click="gotoDistribution"
                          >Buildings</a
                        >
                      </li>

                      <li
                        v-if="
                          userInfo &&
                            (RoleOfUser === '11' || RoleOfUser === '14')
                        "
                        :class="{
                          active: currentPath === 'inquiry',
                        }"
                      >
                        <a class="nav-link cursor-pointer" @click="gotoInquiry"
                          >Inquiries</a
                        >
                        <!-- <a class="notification-badges ">
                          <svg
                            width="16"
                            height="17"
                            viewBox="0 0 16 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.51237 7.16655C3.51154 6.56657 3.62809 5.97235 3.8553 5.41815C4.08251 4.86394 4.41588 4.36072 4.8362 3.93749C5.25652 3.51426 5.75547 3.17938 6.3043 2.95216C6.85313 2.72495 7.44099 2.60989 8.03397 2.61361C10.5083 2.63222 12.4875 4.71317 12.4875 7.22371V7.67245C12.4875 9.93733 12.9558 11.2516 13.3683 11.9699C13.4128 12.0467 13.4364 12.1339 13.4369 12.2229C13.4374 12.3118 13.4146 12.3993 13.371 12.4766C13.3274 12.5538 13.2644 12.618 13.1884 12.6628C13.1124 12.7075 13.0261 12.7312 12.9382 12.7314H3.06116C2.97323 12.7312 2.88692 12.7075 2.81093 12.6627C2.73495 12.618 2.67197 12.5538 2.62835 12.4765C2.58473 12.3993 2.56202 12.3117 2.56251 12.2228C2.56299 12.1338 2.58666 12.0466 2.63112 11.9698C3.04382 11.2515 3.51237 9.93721 3.51237 7.67245L3.51237 7.16655Z"
                              stroke="#09514B"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M6 12.7314V13.2373C6 13.774 6.21071 14.2888 6.58579 14.6683C6.96086 15.0478 7.46957 15.261 8 15.261C8.53043 15.261 9.03914 15.0478 9.41421 14.6683C9.78929 14.2888 10 13.774 10 13.2373V12.7314"
                              stroke="#09514B"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span
                            v-if="notificationCount > 0"
                            class="data-badge"
                            >{{
                              notificationCount <= 9 ? notificationCount : '9+'
                            }}</span
                          >
                        </a> -->
                      </li>
                      <li
                        v-if="
                          userInfo &&
                            (RoleOfUser === '11' || RoleOfUser === '14')
                        "
                        class=""
                        :class="{
                          active:
                            currentPath === 'reporting' ||
                            currentPath === 'reportAnalysis',
                        }"
                      >
                        <a
                          class="nav-link cursor-pointer"
                          @click="gotoAdminReportSection"
                          >Reports</a
                        >
                      </li>
                      <!-- commenting on 07-10-2022
                      <li
                        v-if="
                          userInfo &&
                            (RoleOfUser === '11' || RoleOfUser === '14')
                        "
                        class=""
                        :class="{
                          active: currentPath === 'setting',
                        }"
                      >
                        <a
                          class="nav-link cursor-pointer"
                          @click="gotoRoute('setting')"
                          >Setting</a
                        >
                      </li>
                      <li
                        v-if="
                          userInfo &&
                            (RoleOfUser === '11' || RoleOfUser === '14')
                        "
                        class=""
                        :class="{
                          active:
                            currentPath === 'adminorder' ||
                            currentPath === 'viewmilestone',
                        }"
                      >
                        <a
                          class="nav-link cursor-pointer"
                          @click="gotoRoute('adminorder')"
                          >Orders</a
                        >
                      </li>
                      <li
                        v-if="
                          userInfo &&
                            (RoleOfUser === '11' || RoleOfUser === '14')
                        "
                        class=""
                        :class="{
                          active:
                            currentPath === 'adminpayout' ||
                            currentPath === 'payout-history',
                        }"
                      >
                        <a
                          class="nav-link cursor-pointer"
                          @click="gotoRoute('adminpayout')"
                          >Payouts</a
                        >
                      </li> -->
                      <!-- uncommenting on 07-10-2022 -->
                      <li
                        v-if="
                          userInfo &&
                            (RoleOfUser === '11' || RoleOfUser === '14')
                        "
                        class="mr-r20"
                      >
                        <a
                          href="https://analytics.google.com/analytics/web/?authuser=0#/my-reports/Dg6T6iPLSImDm2-2wp9HDA/a167089209w233202846p218900459/"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="nav-link cursor-pointer"
                          >Analytics</a
                        >
                      </li>
                      <!-- Sando Admin Tab Ends Here -->
                      <!-- Resident Tab Start From Here -->
                      <li
                        v-if="
                          userInfo &&
                            RoleOfUser !== '11' &&
                            RoleOfUser !== '14' &&
                            RoleOfUser !== '18'
                        "
                      ></li>
                      <li
                        v-if="
                          userInfo &&
                            RoleOfUser !== '11' &&
                            RoleOfUser !== '14' &&
                            RoleOfUser !== '18'
                        "
                      ></li>
                      <li
                        v-if="
                          userInfo &&
                            RoleOfUser !== '11' &&
                            RoleOfUser !== '14' &&
                            RoleOfUser !== '18'
                        "
                      ></li>
                      <li
                        v-if="
                          userInfo &&
                            RoleOfUser !== '11' &&
                            RoleOfUser !== '14' &&
                            RoleOfUser !== '18'
                        "
                      ></li>
                      <li
                        v-if="
                          userInfo &&
                            RoleOfUser !== '11' &&
                            RoleOfUser !== '14' &&
                            RoleOfUser !== '18'
                        "
                      ></li>
                      <li
                        v-if="
                          userInfo &&
                            RoleOfUser !== '11' &&
                            RoleOfUser !== '14' &&
                            RoleOfUser !== '18'
                        "
                        :class="{
                          active: currentPath === 'buildingLinkServices',
                        }"
                      >
                        <a
                          class="nav-link cursor-pointer"
                          @click="residentNavigation"
                          >Services & Offers</a
                        >
                      </li>

                      <li
                        v-if="
                          userInfo &&
                            RoleOfUser !== '11' &&
                            RoleOfUser !== '14' &&
                            RoleOfUser !== '18'
                        "
                        class=""
                        :class="{
                          active: currentPath === 'InquiriesHistory',
                        }"
                      >
                        <a
                          class="nav-link cursor-pointer"
                          @click="gotoInquiriesHistory"
                          >My Inquiries</a
                        >
                      </li>
                      <!-- commenting on 07-10-2022
                      <li
                        v-if="
                          userInfo &&
                            RoleOfUser !== '11' &&
                            RoleOfUser !== '14' &&
                            RoleOfUser !== '18'
                        "
                        class="mr-r20"
                        :class="{
                          active:
                            currentPath === 'residentorder' ||
                            currentPath === 'viewmilestone',
                        }"
                      >
                        <a
                          class="nav-link cursor-pointer"
                          @click="gotoRoute('residentorder')"
                          >My Orders</a
                        >
                      </li> -->
                      <!-- Resident Tabt End Here -->
                      <!-- -------------------------------------------------------------- -->
                      <!-- Vendor Role Tab Start from Here -->

                      <li
                        v-if="userInfo && RoleOfUser === '18'"
                        :class="{
                          active:
                            currentPath === 'vendorServicesForms' ||
                            currentPath === 'vendorCreateServiceForm',
                        }"
                      >
                        <a
                          class="nav-link cursor-pointer"
                          @click="gotoServices"
                        >
                          <!-- Vendor Forms -->
                          Vendor Services
                        </a>
                      </li>
                      <li
                        v-if="userInfo && RoleOfUser === '18'"
                        class="mr-r10"
                        :class="{
                          active: currentPath === 'vendorinquiry',
                        }"
                      >
                        <a
                          class="nav-link cursor-pointer"
                          @click="gotoVendorInquiry"
                          >My Inquiries
                        </a>
                      </li>
                      <!-- commenting on 07-10-2022
                      <li
                        v-if="userInfo && RoleOfUser === '18'"
                        class="mr-r10"
                        :class="{
                          active:
                            currentPath === 'vendororder' ||
                            currentPath === 'viewmilestone',
                        }"
                      >
                        <a
                          class="nav-link cursor-pointer"
                          @click="gotoRoute('vendororder')"
                          >My Orders
                        </a>
                      </li>
                      <li
                        v-if="userInfo && RoleOfUser === '18'"
                        class="mr-r10"
                        :class="{
                          active: currentPath === 'vendorReport',
                        }"
                      >
                        <a
                          class="nav-link cursor-pointer"
                          @click="gotoRoute('vendorReport')"
                          >Reports
                        </a>
                      </li> -->
                      <li v-if="userInfo && RoleOfUser === '18'"></li>
                      <li v-if="userInfo && RoleOfUser === '18'"></li>
                      <li v-if="userInfo && RoleOfUser === '18'"></li>
                      <li v-if="userInfo && RoleOfUser === '18'"></li>
                      <!-- <li v-if="userInfo && RoleOfUser === '18'"></li> -->

                      <!-- Vendor Role Tab End Here -->
                      <li style="" class="nav-item avatar xs-pointer-none disP">
                        <div class="dropdown">
                          <a
                            id="dropdownMenuLink"
                            class="dropdown-toggle"
                            href="#"
                            role="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <div class="nav-profile">
                              <!-- <img
                                src="https://mdbootstrap.com/img/Photos/Avatars/avatar-2.jpg"
                                alt=""
                                class="rounded-circle z-depth-0"
                                width="40%"
                                :title="userInfo.FirstName"
                              /> -->
                              <!-- <span
                            v-if="notificationCount > 0"
                            class="data-badge"
                            >{{
                              notificationCount <= 9 ? notificationCount : '9+'
                            }}</span
                          > -->

                              <i
                                v-if="userInfo !== null"
                                class="fa fa-user-circle-o clr profPic"
                                aria-hidden="true"
                                :title="userInfo ? userInfo.name : ''"
                                style="display: flex;"
                              >
                                <!-- <p style="display: block;" class="nav-link"
                                  >{{ userInfo.name }}
                                  {{ userInfo.LastName }}</p
                                > -->
                              </i>
                              <span
                                v-if="notificationCount > 0"
                                class="data-badge"
                                style="cursor:default !important"
                                >{{
                                  notificationCount <= 9
                                    ? notificationCount
                                    : '9+'
                                }}</span
                              >
                              <div class="profile-info">
                                <p style="display: block;" class="nav-link">{{
                                  userInfo.name
                                }}</p>
                                <h6 class="text-center userrole">
                                  {{
                                    RoleOfUser === '18'
                                      ? 'Vendor'
                                      : RoleOfUser === '15'
                                      ? 'Resident'
                                      : RoleOfUser === '11' ||
                                        RoleOfUser === '14'
                                      ? 'SandO Admin'
                                      : 'Resident'
                                  }}</h6
                                >
                              </div>
                            </div>
                          </a>

                          <div
                            class="dropdown-menu dropdown-menu-left p-2 mt-2"
                            aria-labelledby="dropdownMenuLink"
                          >
                            <table class="bio-table">
                              <tbody>
                                <tr class="verticalAlign">
                                  <th class="username pr-0">
                                    Name&emsp;
                                  </th>
                                  <!-- <th class="username pl-0 breakWord">
                                    {{ userInfo ? userInfo.FirstName : '' }}
                                    {{ userInfo ? userInfo.LastName : '' }}
                                  </th> -->
                                  <th class="username pl-0 breakWord">
                                    {{ userInfo ? userInfo.name : '' }}
                                  </th>
                                </tr>
                              </tbody>
                            </table>

                            <div class="text-center" style="color: white;">
                              <a
                                class="btn bg-red btn-sm mt-2 nav-link cursor-pointer"
                                @click="loginPopup = !loginPopup"
                              >
                                <span class="glyphicon glyphicon-log-out"></span
                                ><h6 style="font-size: 14px;">Logout</h6>
                              </a>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="nav-item xs-logout-link lg-logout">
                        <a
                          href="#"
                          class="nav-link"
                          @click="loginPopup = !loginPopup"
                        >
                          Logout
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div v-if="loginPopup">
        <transition name="modal">
          <div class="modal-mask modal-mask-height">
            <div class="modal-wrapper">
              <div class="modal-dialog">
                <div class="modal-content yesNoPad" style="padding: 50px;">
                  <!-- <div class="modal-header pull-right control-group">
                    <button
                      type="button"
                      class="close"
                      aria-label="Close"
                      @click=";(loginPopup = false), (popup = false)"
                      style="padding:0px"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div> -->
                  <div class="mt-2 mb-4">
                    <h4 class="modal-title text-center">
                      Are you sure you want to logout ?</h4
                    >
                  </div>

                  <div class="col-12 text-center">
                    <!--  <button
                      id="show-modal"
                      type="button"
                      class="btn btn-danger  btn-sm trans-btn trans-btn-border col-sm-6"
                      @click="gotoLogin(true)"
                    >
                      OK
                    </button> -->
                    <div class="m-btn-wrap mr-t20">
                      <!-- <a id="1" type="submit" href="#" class="btn s-red-btn mr-r20  pointer" >
                                                Approve
                                            </a> -->
                      <button
                        type="submit"
                        data-toggle="modal"
                        data-target="#requestModal"
                        class="btn s-red-btn mr-r20 pointer min-width getFont"
                        @click="gotoLogin(true)"
                      >
                        Yes
                      </button>
                      <a
                        id="2"
                        data-dismiss="modal"
                        class="btn pd-l20 pd-r20 trans-btn pointer min-width getFont"
                        @click="gotoLogin(false)"
                      >
                        No
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </section>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { env } from '@/env'
import {
  authComputed,
  authMethods,
  providerMethods,
  superAdminMethods,
} from '@state/helpers'
const CryptoJS = require('crypto-js')
export default {
  data() {
    return {
      userInfo: null,
      currentPath: '',
      popup: false,
      loginPopup: false,
      postMessage: 'vxcbz gdszb',
      profimg: true,
      show: false,
      activeServiceCount: 0,
      RoleOfUser: null,
      interval: '',
      notificationCount: 0,
      providerId: 0,
      residentId: 0,
    }
  },
  computed: {
    ...authComputed,
  },
  created() {
    // Decode the user info from the token
    this.getUserInfo_BLK()
    // Current Path of route
    this.currentPath = this.$route.path.split('/')[2]
    console.log('created -> this.currentPath', this.currentPath)
    this.providerId = window.localStorage.getItem('bussinesId')
    this.residentId = window.localStorage.getItem('subId')
    this.getNoficationCount()
    // this.callnotificationAPI()

    // No need if user is not log In
    // if (this.userInfo) {
    //   this.loadRequests()
    // }
  },

  methods: {
    ...authMethods,
    ...providerMethods,
    ...superAdminMethods,

    // Oidc Action imported

    ...mapActions('oidcStore', [
      'authenticateOidcPopup',
      'removeOidcUser',
      'signOutOidc',
      'signOutOidcSilent',
    ]),

    // callnotificationAPI() {
    //   setInterval(() => {
    //     this.getNoficationCount()
    //   }, 60000)
    // },

    async getNoficationCount() {
      try {
        var Request = {
          providerId: this.providerId ? this.providerId : 0,
          residentId: this.residentId ? this.residentId : 0,
        }
        const response = await this.getNoficationCount_BLK(Request)
        console.log('response:', response)
        this.notificationCount = response.data.result.UnreadMessage
      } catch (error) {}
    },

    providerNavigation() {
      console.log('Navigation provider')
      // this.$router.push('/provider/serviceRequests/3')
      this.$router.push({ name: 'serviceRequestsVendor' })
    },
    // Route Navigation
    superAdminNavigation() {
      console.log('Navigation Super Admin')
      this.$router.push('/superAdmin/manageVendor')
    },
    // Route Navigation
    residentNavigation() {
      console.log('Navaigation Resident')
      // this.$router.push('/resident/servicesOffers')
      this.$router.push({ name: 'landingPage' })
    },
    // Route Navigation
    gotoLogin(val) {
      console.log('gotologin', val)
      this.loginPopup = false

      if (val === true) {
        this.signOutOidc()
        sessionStorage.clear()
      }
    },
    signOut: function() {
      console.log('In signout function 1')
      this.removeOidcUser().then(() => {
        console.log('redirection')
        this.$router.push('/login')
      })
    },
    // Route Navigation
    gotoServices() {
      this.$router.push({ name: 'vendorServicesForms' })
    },
    // Route Navigation

    gotoServicesCreation() {
      localStorage.removeItem('search_vendor')
      this.$router.push({ name: 'vendor-service' })
    },
    // Route Navigation

    gotoVendorCreation() {
      localStorage.removeItem('search_vendor')
      this.$router.push({ name: 'manage-vendor' })
    },
    // Route Navigation

    gotoDistribution() {
      localStorage.removeItem('search_vendor')
      this.$router.push({ name: 'manage-distribution' })
    },
    // Routing
    gotoRoute(val) {
      if (val == 'setting') this.$router.push({ name: 'paymentsetting' })
      else this.$router.push({ name: val })
    },
    // Token Decode

    getUserInfo_BLK() {
      console.log('-------------------------currentUser:', this.currentUser)
      let secretKey = env.VUE_APP_SECRET_KEY
      if (!window.localStorage.getItem('auth.authToken')) {
        return
      }
      const bytes = CryptoJS.AES.decrypt(
        window.localStorage.getItem('auth.authToken')
          ? window.localStorage.getItem('auth.authToken').toString()
          : '',
        secretKey
      )
      const serializedState = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))

      if (serializedState === null) {
        this.userInfo = undefined
        console.log('this.userInfo', this.userInfo)
      } else {
        this.userInfo = serializedState
        this.RoleOfUser = this.userInfo.user_type_id.substring(0, 2)
        console.log('this.userInfo', this.userInfo)
      }
    },
    // Route Navigation

    gotoInquiry() {
      localStorage.removeItem('search_vendor')
      this.$router.push({ name: 'inquiry' })
    },
    // Route Navigation

    gotoVendorInquiry() {
      this.$router.push({ name: 'vendorinquiry' })
    },
    // Route Navigation

    gotoAdminReportSection() {
      localStorage.removeItem('search_vendor')
      this.$router.push({ name: 'reporting' })
    },
    // Route Navigation

    gotoInquiriesHistory() {
      this.$router.push({ name: 'InquiriesHistory' })
    },
  },
}
</script>
<style>
.notification-badges {
  position: relative;
  margin-bottom: 7px;
}
.data-badge {
  position: inherit;
  margin-top: -31px;
  margin-left: -3px;
  top: -11px;
  right: -10px;
  background-color: #d13851;
  color: white;
  font-size: 10px;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  text-align: center;
  padding: 2px 2px;
  font-weight: bold;
}
#myServiceRequestCount.badge-light {
  color: white;
  background-color: #d13851;
  border-radius: 50%;
}
.headerlogo {
  display: flex;
}
.active {
  color: #d13851;
}
.header-logo {
  /* height: 64px; */
  height: 58px;
  margin-left: -18px;
  /* width: 483px; */
}

.modal-mask {
  position: fixed;
  z-index: 9000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-header {
  border-bottom: none;
}
.b-name {
  font-family: Josefin Sans;
  font-weight: 800;
  font-size: 18px;
}
.mt-4,
.my-4 {
  margin-top: 1.6rem !important;
}
.clr {
  color: #d13851;
}
/* .nav-profile {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
}
.nav-profile img {
  width: 60px;
  height: 60px;
  object-fit: cover;
}*/
.nav-profile {
  display: flex;
  align-items: center;
}
.profile-info {
  margin-left: 10px;
}
.profile-info p.nav-link {
  padding-right: 0 !important;
  padding-left: 0 !important;
  line-height: 20px;
  padding: 0px;
}
.nav-profile::after {
  display: none;
}
.dropdown-toggle::after {
  display: none;
}

.bg-red {
  background-color: #d13851;
  color: white;
}

.min-width {
  min-width: 125px;
}
.profPic {
  font-size: 30px;
}
.nav-link {
  font-family: 'JosefinSans-SemiBold' !important;
  font-size: 17px;
}
.dropdown-menu {
  font-size: 14px;
  font-family: 'JosefinSans' !important;
}
.username {
  font-family: 'JosefinSans-SemiBold' !important;
  font-size: 14px;
}
.dropdown-toggle::after {
  display: none !important;
}

.cursorClass {
  cursor: pointer;
}
.userrole {
  font-size: 11px;
  /* margin-left: 26px; */
  color: #ada4a4cc;
}
/* #navbarSupportedContent.navbar-collapse{
  position: initial;
  margin-top: -22px;
  margin-left: 17px;
} */
.disP {
  margin-right: -22px;
}
@media screen and (max-width: 991px) {
  #navbarSupportedContent.navbar-collapse.show {
    position: initial;
    /* margin-top: -22px;
  margin-left: -16px; */
  }
}
@media screen and (max-width: 478px) {
  .logoAdjust {
    display: inline-table;
  }
  .logoAdjust .mt-4 {
    margin-top: 0 !important;
  }
  .logoAdjust .mb-2 {
    margin-bottom: 0 !important;
  }
}
.verticalAlign {
  vertical-align: text-top !important;
}
.breakWord {
  word-break: break-word;
}
.head-right-nav li {
  margin-left: 0 !important;
}
@media (min-width: 992px) {
  .lg-logout {
    display: none !important;
  }

  .mr-l {
    margin-right: 23px;
  }
}
@media (max-width: 991px) {
  .mr-l {
    margin-right: 0;
  }
  .head-logo img {
    /* width: 330px; */
    width: 255px;
  }

  .header-logo {
    height: 46px;
  }
  .navbar-toggler {
    padding: 0 !important;
    border: 1px solid !important;
    height: 29px !important;
    font-size: 1.45rem !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .navbar-toggler-icon {
    line-height: 0 !important;
    height: auto !important;
  }
  .yesNoPad {
    padding: 23px !important;
  }
  .m-btn-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .m-btn-wrap button,
  .m-btn-wrap .trans-btn {
    width: 40%;
    min-width: 40%;
    height: 40px;
    border-radius: 0px !important;
    line-height: normal;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #navbarSupportedContent {
    position: fixed;
    left: 0px;
    top: 0px;
    background: rgb(255, 255, 255);
    z-index: 99;
    width: 190px;
    height: 100% !important;
    display: block !important;
    transform: translateX(-200px);
    -webkit-transform: translateX(-200px);
    -moz-transform: translateX(-200px);
    -ms-transform: translateX(-200px);
    -o-transform: translateX(-200px);
    box-shadow: 0px 0px 5px #afabab;
    padding: 15px 15px;
    -webkit-transition: transform 0.35s ease-in-out;
    -moz-transition: transform 0.35s ease-in-out;
    -o-transition: transform 0.35s ease-in-out;
    transition: transform 0.35s ease-in-out;
    padding: 0px;
  }
  #navbarSupportedContent.show {
    position: fixed !important;
    transform: translateX(0px);
    -webkit-transform: translateX(0px);
    -moz-transform: translateX(0px);
    -ms-transform: translateX(0px);
    -o-transform: translateX(0px);
    -webkit-transition: transform 0.35s ease-in-out;
    -moz-transition: transform 0.35s ease-in-out;
    -o-transition: transform 0.35s ease-in-out;
    transition: transform 0.35s ease-in-out;
    height: 100% !important;
  }
  .clr,
  .userrole {
    color: #ffffff;
  }
  .profile-info p.nav-link {
    color: #ffffff;
  }

  .navbar-nav.head-right-nav,
  .form-inline.my-2 {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
  .head-right-nav li {
    padding: 0px 15px;
  }
  .head-right-nav li:nth-child(1) {
    order: 2;
  }
  .head-right-nav li:nth-child(2) {
    order: 3;
  }
  .head-right-nav li:nth-child(3) {
    order: 4;
  }
  .head-right-nav li:nth-child(4) {
    order: 5;
  }
  .head-right-nav li:nth-child(5) {
    order: 6;
  }
  .head-right-nav li:nth-child(6) {
    order: 7;
  }
  .head-right-nav li:nth-child(7) {
    order: 8;
  }
  .head-right-nav li:nth-child(8) {
    order: 9;
  }
  .head-right-nav li:nth-child(9) {
    order: 10;
  }
  .head-right-nav li:nth-child(10) {
    order: 109;
  }
  .head-right-nav li:nth-child(9) {
    order: 1;
    margin-bottom: 5px;
    border-bottom: 1px solid #dacfcf;
    padding: 14px 15px;
    width: 100%;
    background: #d13851;
  }
  .head-right-nav li:nth-child(4) .dropdown-menu.show {
    display: block !important;
    border: 0px;
    padding: 0px !important;
    margin-top: 10px;
  }
  .head-right-nav li:nth-child(4) .dropdown-menu.show .bio-table {
    display: none;
  }
  .head-right-nav li:nth-child(4) .dropdown-menu.show .btn-sm {
    margin: 12px 0 0 !important;
    border: 1px solid;
    border-radius: 5px;
  }
  .xs-logout-link {
    display: block;
  }
  .xs-pointer-none {
    pointer-events: none;
  }
}
.xs-logout-link {
  display: none;
}
button:focus {
  outline: none !important;
}
</style>
